import * as React from 'react';
import * as reg from "./style.module.scss";
import { WebDate } from "../../../../WebDate";
export const Reg = ({ widget, id }) => {
  return (
    <section className={reg.reg}>
      <div className="container">
        <div className={reg.inner}>
          <div className={reg.desc}>

            <p className={reg.title}>
              Регистрируйтесь на бесплатный вебинар
            </p>
            <time className={reg.time}>
              <WebDate id={id}/>
            </time>
            <h3 className={`${reg.title} ${reg.small}`}>
              Онлайн-участие из любой точки мира
            </h3>
          </div>
          <div className={reg.widget} id={"widget"}>
            { widget }
          </div>
        </div>
      </div>
    </section>
  );
};
